import { defineMessages, FormattedMessage } from 'react-intl';

import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';
import { paths } from '@/lib/paths';

const intlPrefix = 'warrantySection';

export const Description = (
  <FormattedMessage
    defaultMessage='Your Breitling watch or chronograph is guaranteed against any
    manufacturing defect as set out under this terms and conditions
    (“Breitling International Warranty”), taking effect as of the date of
    purchase of the watch (“Warranty Period”).'
    id={`${intlPrefix}.description`}
  />
);

export const Duration = (
  <FormattedMessage
    defaultMessage='Warranty Duration (Years)'
    id={`${intlPrefix}.duration`}
  />
);

export const defined = defineMessages({
  years: {
    id: 'pdp.warranty.years',
    defaultMessage: '+{warrantyExtDuration} YEARS',
  },
});

export const MechanicalMovements = (
  <FormattedMessage
    defaultMessage='Mechanical manufacture Breitling movements'
    id='pdp.warranty.mechanicalMovements'
  />
);

export const OtherMovements = (
  <FormattedMessage
    defaultMessage='Other Breitling movements'
    id='pdp.warranty.otherBreitlingMovements'
  />
);

export const ExtendDescription = (
  <FormattedMessage
    defaultMessage='You can extend the warranty the current warranty on your Breitling watch by an additional 2 years from the date of purchase, or even 3 years for watches equipped with a mechanical manufacture movement.'
    id={`${intlPrefix}.extendDescription`}
  />
);

export const ExtendLink = (
  <FormattedMessage
    defaultMessage='Extend my warranty'
    id={`${intlPrefix}.extendLink`}
  />
);
export const TermsAndConditionsMessage = (
  <FormattedMessage
    defaultMessage='Terms & Conditions'
    id='placeholder.termsAndConditions'
  />
);
export const WarrantyTerms = () => (
  <FormattedMessage
    defaultMessage='Visit Breitling’s {termsAndConditions} for warranty details.'
    id='placeholder.visitWarrantyTerms'
    values={{
      termsAndConditions: (
        <LinkWithLocale href={paths.termsAndCondition.url()}>
          {TermsAndConditionsMessage}
        </LinkWithLocale>
      ),
    }}
  />
);
